export default __webpack_public_path__ + "static/media/duck.837479db.png";